<template>
    <div class="public_container">
        <div class="returnNavBar">
            <ReturnNavBar :isAllFunctions="false" :isTitleNormal="true" title="返回"></ReturnNavBar>
            <div class="returnNavBarRight">
                <i class="iconfont icon-gengduo1" @click="handleClickMore"></i>
            </div>
        </div>
        <van-tabs
            v-model="tabActiveName"
            color="#2990ff"
            title-active-color="#2990ff"
            title-inactive-color="#666666"
            sticky
            :ellipsis="false"
        >
            <van-tab name="detail" title="工单信息">
                <div class="detail_tab_content" v-loading="loading">
                    <CustomFormDetailMobile
                        v-if="dataLoaded"
                        :field_form="'workorders'"
                        :field_list="formInfoList"
                        :form_detail="workOrderDetailsData"
                        :is_edit_mode="false"
                        :pk_id="workOrderDetailsData.id"
                    />
                </div>
            </van-tab>
            <van-tab name="assign" title="工单指派分配">
                <div class="detail_tab_content detail_assign_tab_content">
                    <ul>
                        <li v-for="row in assignData" :key="row.id" class="list_item">
                            <div class="list_item_field list_item_field_status">
                                <div>
                                    <span class="list_item_field_label">实施人员：</span>
                                    <div
                                        class="mobile_list_head_user"
                                        v-if="row.processing_user && row.processing_user.id"
                                    >
                                        <img
                                            :src="row.processing_user.avatar ? row.processing_user.avatar : defaultImg"
                                            alt=""
                                        />
                                        <span class="ellipsis">{{
                                            row.processing_user && row.processing_user.name
                                        }}</span>
                                    </div>
                                </div>
                                <span class="work_order_status" :class="'work_order_status' + row.status">{{
                                    row.status_text
                                }}</span>
                            </div>
                            <div class="list_item_field">
                                <span class="list_item_field_label">指派时间：</span>
                                <span v-if="row.plan_start_date === row.plan_end_date"
                                    >{{ row.plan_start_date ? formatDate(row.plan_start_date, "date") : "" }}
                                    {{ row.plan_start_time == 1 ? "上午" : "下午" }}-{{
                                        row.plan_end_time == 1 ? "上午" : "下午"
                                    }}</span
                                >
                                <span v-else
                                    >{{ row.plan_start_date ? formatDate(row.plan_start_date, "date") : "" }}
                                    {{ row.plan_start_time == 1 ? "上午" : "下午" }}-{{
                                        row.plan_end_date ? formatDate(row.plan_end_date, "date") : ""
                                    }}
                                    {{ row.plan_end_time == 1 ? "上午" : "下午" }}</span
                                >
                            </div>
                            <div class="list_item_field">
                                <span class="list_item_field_label">实际时间：</span>
                                <span v-if="row.start_date || row.end_date">
                                    {{ row.start_date ? formatDate(row.start_date, "date") : "" }}
                                    {{ row.start_time == 1 ? "上午" : "下午" }}-{{
                                        row.end_date
                                            ? `${row.end_date}-${row.end_time == 1 ? "上午" : "下午"}`
                                            : "未完成"
                                    }}
                                </span>
                                <span v-else>未出发</span>
                            </div>
                            <div class="list_item_field">
                                <span class="list_item_field_label">分数：</span>
                                <template v-if="row.evaluate && row.evaluate.id">
                                    <span v-if="row.evaluate && row.evaluate.id">{{ row.evaluate.star }}分</span>
                                    <span
                                        class="handle_icon_wrap handle_icon_wrap_shuoming"
                                        v-if="row.evaluate.content"
                                        @click="handleClickShowContent(row.evaluate.content)"
                                    >
                                        <i class="iconfont icon-shuoming"></i>
                                    </span>
                                </template>
                                <span v-else>--</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </van-tab>
            <van-tab name="feedback" title="工单处理详情" v-if="feedBackData.length">
                <div class="detail_tab_content detail_feedback_tab_content">
                    <div class="user_tab_wrap">
                        <span
                            v-for="(user, userIndex) in feedBackData"
                            :key="user.uid"
                            :class="{ active: user.uid === feedBackTabActiveId }"
                            @click="handleClickUserTab(user, userIndex)"
                            >{{ user.name }}</span
                        >
                    </div>
                    <div class="user_tab_content_wrap">
                        <ul>
                            <li v-for="row in feedBackTabData" :key="row.id" class="list_item">
                                <div class="list_item_field list_item_field_status">
                                    <div>
                                        <span class="list_item_field_label">工作日期：</span>
                                        <span>{{ row.work_date ? formatDate(row.work_date, "date") : "--" }}</span>
                                    </div>
                                    <span class="link-label">打卡详情</span>
                                </div>
                                <div class="list_item_field list_item_field_vertical">
                                    <span class="list_item_field_label">工作内容：</span>
                                    <div>
                                        <p>{{ row.work_content || "暂无工作内容" }}</p>
                                        <div class="image_outer_wrap" v-if="row.files_image && row.files_image.length">
                                            <ul class="upload_image_list">
                                                <li
                                                    v-for="item in row.files_image"
                                                    :key="item.file_path"
                                                    class="upload_image_item"
                                                >
                                                    <el-image
                                                        :preview-src-list="row.files_image.map((img) => img.file_path)"
                                                        :src="item.file_path"
                                                        fit="cover"
                                                    >
                                                    </el-image>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="commentFiles" v-if="row.files_file && row.files_file.length">
                                            <ul>
                                                <li v-for="(file, fileIndex) in row.files_file" :key="fileIndex">
                                                    <p class="ellipsis" v-text="file.file_name"></p>
                                                    <div>
                                                        <span
                                                            class="handle_icon_wrap"
                                                            @click="handleClickPreview(file)"
                                                        >
                                                            <i class="iconfont icon-yanjing"></i>
                                                        </span>
                                                        <span
                                                            class="handle_icon_wrap"
                                                            @click="handleClickDownloadFile(fileIndex)"
                                                        >
                                                            <i class="iconfont icon-daochu"></i>
                                                        </span>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </van-tab>
            <van-tab name="finish" title="结单信息" v-if="finishAllData.length">
                <div class="detail_tab_content detail_finish_tab_content">
                    <ul>
                        <li class="list_item_form">
                            <p class="list_item_label">结单时间</p>
                            <div class="list_item_content">
                                <span>{{
                                    finishData && finishData.created_at
                                        ? formatDate(finishData.created_at, "date")
                                        : "--"
                                }}</span>
                            </div>
                        </li>
                        <li class="list_item_form">
                            <p class="list_item_label">结单人、实施人</p>
                            <div class="list_item_content">
                                <span class="link-label">{{
                                    finishData && finishData.user && finishData.user.name
                                }}</span>
                            </div>
                        </li>
                        <li class="list_item_form">
                            <p class="list_item_label">工单起止时间</p>
                            <div class="list_item_content">
                                <span
                                    >{{
                                        (finishData && finishData.start_date
                                            ? formatDate(finishData.start_date, "date")
                                            : "") +
                                        "-" +
                                        (finishData && finishData.end_date
                                            ? formatDate(finishData.end_date, "date")
                                            : "")
                                    }}（共{{ finishData && finishData.duration }}人日）</span
                                >
                            </div>
                        </li>
                        <li class="list_item_form">
                            <p class="list_item_label">实施报告/证明</p>
                            <div class="list_item_content">
                                <div class="file_upload_wrap" v-if="finishData && finishData.files.length">
                                    <ul class="upload_file_list upload_file_list_detail">
                                        <li v-for="file in finishData.files" class="upload_file_item">
                                            <div class="file_left_wrap">
                                                <img
                                                    alt=""
                                                    class="file_img"
                                                    src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png"
                                                />
                                                <div class="file_info_wrap">
                                                    <p class="file_name" v-text="file.file_name"></p>
                                                    <p class="file_size" v-text="file.file_size"></p>
                                                </div>
                                            </div>
                                            <div class="file_right_wrap">
                                                <el-tooltip content="预览" effect="dark" placement="top">
                                                    <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                        <i class="iconfont icon-yanjing"></i>
                                                    </span>
                                                </el-tooltip>
                                                <span class="line"></span>
                                                <el-tooltip content="下载" effect="dark" placement="top">
                                                    <span
                                                        class="handle_icon_wrap"
                                                        @click="handleClickDownloadFile(file)"
                                                    >
                                                        <i class="iconfont icon-daochu"></i>
                                                    </span>
                                                </el-tooltip>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                        <li class="list_item_form">
                            <p class="list_item_label">结单描述</p>
                            <div class="list_item_content">
                                <span>{{ finishData && finishData.note }}</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </van-tab>
        </van-tabs>
        <el-image ref="preview_img" :preview-src-list="previewImgList" :src="previewImgSrc" style="display: none">
        </el-image>
        <van-overlay
            :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"
            z-index="1000"
            v-if="handleRadioPicker"
            :show="handleRadioPicker"
            @click="handleRadioPicker = false"
        >
            <div class="custome_radio_option_wrap">
                <!-- 工单状态：0=>审批中，1=>待指派，2=>待出发，3=>待实施，4=>实施中，5=>实施完成，6=>已结单，7=>已评价,-1=>已拒绝，-2=>已撤销，-3=>已关闭 -->
                <!-- 实施人状态：0=>未出发，1=>待实施, 2=>实施中, 3=>实施完成 -->
                <ul class="radio_option_list">
                    <li
                        class="radio_option_item"
                        v-if="(activeItem.status == -1 || activeItem.status == -2) && activeItem.uid === owner_uid"
                        @click="handleClickDelWorkOrder(activeItem)"
                    >
                        删除
                    </li>
                    <li
                        class="radio_option_item"
                        v-if="activeItem.status === 0 && activeItem.uid === owner_uid"
                        @click="handleClickRevokeWorkOrder(activeItem)"
                    >
                        撤销
                    </li>
                    <li
                        class="radio_option_item"
                        v-if="
                            (activeItem.status === 1 ||
                                activeItem.status === 2 ||
                                activeItem.status === 3 ||
                                activeItem.status === 4 ||
                                activeItem.status === 5) &&
                            activeItem.uid === owner_uid
                        "
                        @click="handleClickCloseWorkOrder(activeItem)"
                    >
                        关闭工单
                    </li>
                    <li
                        class="radio_option_item"
                        v-if="
                            (activeItem.status == -1 || activeItem.status == -2 || activeItem.status == -3) &&
                            activeItem.uid === owner_uid
                        "
                        @click="handleClickRestartWorkOrder(activeItem)"
                    >
                        再次发起
                    </li>
                    <li
                        class="radio_option_item"
                        v-if="
                            (activeItem.status === 1 ||
                                activeItem.status === 2 ||
                                activeItem.status === 3 ||
                                activeItem.status === 4 ||
                                activeItem.status === 5) &&
                            activeItem.is_assign_user
                        "
                        @click="handleClickDistributeWorkOrder(activeItem)"
                    >
                        分配实施人员
                    </li>
                    <li
                        class="radio_option_item"
                        v-if="
                            (activeItem.status === 2 || activeItem.status === 3 || activeItem.status === 4) &&
                            activeItem.is_assign_user
                        "
                        @click="handleClickReplaceWorkOrder(activeItem)"
                    >
                        替换实施人员
                    </li>
                    <li
                        class="radio_option_item"
                        v-if="
                            (activeItem.status === 2 || activeItem.status === 3 || activeItem.status === 4) &&
                            activeItem.is_assign_user
                        "
                        @click="handleClickRevokeDistributeWorkOrder(activeItem)"
                    >
                        撤回实施人员
                    </li>
                    <li
                        class="radio_option_item"
                        v-if="activeItem.processing_status === 0 && activeItem.is_processing_user"
                        @click="handleClickStartWorkOrder(activeItem)"
                    >
                        出发
                    </li>
                    <li
                        class="radio_option_item"
                        v-if="activeItem.processing_status === 1 && activeItem.is_processing_user"
                        @click="handleClickWorkOrderImplementStart(activeItem)"
                    >
                        实施开始
                    </li>
                    <li
                        class="radio_option_item"
                        v-if="
                            (activeItem.processing_status === 0 || activeItem.processing_status === 1) &&
                            workOrderSetForm &&
                            workOrderSetForm.is_transfer === 1 &&
                            activeItem.is_processing_user
                        "
                        @click="handleClickTransferWorkOrder(activeItem)"
                    >
                        转单
                    </li>
                    <li
                        class="radio_option_item"
                        v-if="activeItem.processing_status === 2 && activeItem.is_processing_user"
                        @click="handleClickWorkOrderDailyWork(activeItem)"
                    >
                        每日工作填写
                    </li>
                    <li
                        class="radio_option_item"
                        v-if="activeItem.processing_status === 2 && activeItem.is_processing_user"
                        @click="handleClickWorkOrderImplementEnd(activeItem)"
                    >
                        实施结束
                    </li>
                    <li
                        class="radio_option_item"
                        v-if="
                            activeItem.processing_status === 3 &&
                            activeItem.mode === 2 &&
                            activeItem.is_processing_user &&
                            activeItem.status < 6
                        "
                        @click="handleClickEndWorkOrder(activeItem)"
                    >
                        结单
                    </li>
                    <li
                        class="radio_option_item"
                        v-if="
                            (activeItem.status === 5 &&
                                workOrderSetForm.is_evaluate == 1 &&
                                activeItem.mode === 1 &&
                                activeItem.is_assign_user) ||
                            (activeItem.status === 6 &&
                                workOrderSetForm.is_evaluate == 1 &&
                                activeItem.mode === 2 &&
                                activeItem.is_assign_user)
                        "
                        @click="handleClickEvaluateWorkOrder(activeItem)"
                    >
                        评价
                    </li>
                </ul>
                <div class="cancel_btn" @click="handleRadioPicker = false">取消</div>
            </div>
        </van-overlay>
        <van-dialog
            v-model="showEvaluateContent"
            confirm-button-text="知道了"
            confirm-button-color="#2990FF"
            className="custom_evaluate_dialog"
        >
            <div class="evaluate_content_wrap">
                <div class="evaluate_content_wrap_title">
                    <span>评价</span>
                    <van-icon name="cross" @click="showEvaluateContent = false" />
                </div>
                <div class="evaluate_content_wrap_content">
                    {{ evaluateContent }}
                </div>
            </div>
        </van-dialog>
        <WorkOrderAssign
            v-if="workOrderAssignPopupShow"
            :workOrderAssignPopupShow.sync="workOrderAssignPopupShow"
            :workorder_id="work_order_id"
            :processing_users_selected_ids="processing_users_selected_ids"
            @AssignSuccess="getWorkOrderDetail"
        />
        <WorkOrderProcessingUserReplace
            v-if="workOrderUserReplacePopupShow"
            :workOrderUserReplacePopupShow.sync="workOrderUserReplacePopupShow"
            :workorder_id="work_order_id"
            :processingUserSelectedList="processingUserSelectedList"
            @replaceSuccess="getWorkOrderDetail"
        />
        <WorkOrderProcessingUserRevoke
            v-if="workOrderUserRevokePopupShow"
            :workOrderUserRevokePopupShow.sync="workOrderUserRevokePopupShow"
            :workorder_id="work_order_id"
            :processingUserSelectedList="processingUserSelectedList"
            @revokeSuccess="getWorkOrderDetail"
        />
        <WorkOrderEvaluate
            v-if="workOrderEvaluatePopupShow"
            :workOrderEvaluatePopupShow.sync="workOrderEvaluatePopupShow"
            :workorder_id="work_order_id"
            :workorder_num="workorder_num"
            :processingUserSelectedList="processingUserSelectedList"
            @evaluateSuccess="getWorkOrderDetail"
        />
        <WorkOrderFeedBackFinish
            v-if="workOrderFeedBackFinishPopupShow"
            :workOrderFeedBackFinishPopupShow.sync="workOrderFeedBackFinishPopupShow"
            :workorder_id="work_order_id"
            :workorder_num="workorder_num"
            @feedBackFinishSuccess="getWorkOrderDetail"
        />
    </div>
</template>
<script>
import { mapState } from "vuex";
import { getOSSData } from "@/utils/uploadOss";
import { Dialog } from "vant";
import {
    workOrderSetDetail,
    workOrderDetail,
    workOrderClose,
    workOrderFeedbackStart,
    workOrderFeedbackEnd,
    workOrderRevoke,
} from "@/api";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import CustomFormDetailMobile from "@/components/mComponents/CustomFormDetailMobile.vue";
import WorkOrderAssign from "./work_order_assign.vue";
import WorkOrderProcessingUserReplace from "./work_order_processing_user_replace.vue";
import WorkOrderProcessingUserRevoke from "./work_order_processing_user_revoke.vue";
import WorkOrderEvaluate from "./work_order_evaluate.vue";
import WorkOrderFeedBackFinish from "./work_order_feedback_finish.vue";
export default {
    name: "WorkOrderDetail",
    components: { ReturnNavBar, CustomFormDetailMobile, WorkOrderAssign , WorkOrderProcessingUserReplace, WorkOrderProcessingUserRevoke, WorkOrderEvaluate, WorkOrderFeedBackFinish},
    data() {
        return {
            loading: false,
            defaultImg: require("@/assets/images/default.jpg"),
            work_order_id: this.$route.query.work_order_id && Number(this.$route.query.work_order_id),
            tabActiveName: "detail",
            formInfoList: [],
            dataLoaded: false,
            workOrderDetailsData: {},
            assignData: [],
            feedBackTabActiveId: "",
            feedBackTabData: [], // 当前工单处理详情tab的数据
            feedBackData: [], // 所有的工单处理详情数据，按照姓名分组
            finishAllData: [],
            finishData: {},

            moreFunctionVisible: false,

            // 获取工单后台配置
            workOrderSetForm: {},
            // 操作
            isMoreOperateBtn: true,
            moreOperateType: "",
            isCurrentProcessingUserStatus: null, // 判断当前实施人的状态

            handleRadioPicker: false,
            activeItem: {},

            previewImgList: [],
            previewImgSrc: "",

            showEvaluateContent: false,
            evaluateContent: "",

            workorder_num: "",
            processing_users_selected_ids: [],
            processingUserSelectedList: [],
            workOrderAssignPopupShow: false,
            workOrderUserReplacePopupShow: false,
            workOrderUserRevokePopupShow: false,
            workOrderEvaluatePopupShow: false,
            workOrderFeedBackFinishPopupShow: false
        };
    },
    computed: {
        ...mapState(["userInfo"]),
        owner_uid() {
            return this.userInfo && this.userInfo.user && this.userInfo.user.id;
        },
    },
    created() {
        this.getWorkOrderSetDetail();
        this.getWorkOrderDetail();
    },
    methods: {
        // 获取工单后台配置
        getWorkOrderSetDetail() {
            workOrderSetDetail().then((res) => {
                this.workOrderSetForm = res.data || {};
            });
        },
        // 获取订单详情
        getWorkOrderDetail() {
            this.loading = true;
            this.dataLoaded = false;
            workOrderDetail({
                id: this.work_order_id,
            }).then((res) => {
                if (res.code === 200) {
                    const { workorder, finish, assign, feedback, custom_fields } = res.data;
                    this.workOrderDetailsData = workorder;
                    this.formInfoList = custom_fields;
                    this.dataLoaded = true;

                    // 判断是否有更多操作，并且给下拉框默认显示第一个选项
                    const status = this.workOrderDetailsData.status; // 当前工单状态
                    // 获取当前实施人的状态
                    const isCurrentProcessingUserStatus = this.workOrderDetailsData.processing_status;
                    this.isCurrentProcessingUserStatus = isCurrentProcessingUserStatus;

                    this.assignData = assign;
                    // 将数据按照人员姓名进行分组
                    const userData = this.groupUserData(feedback);
                    let feedBackData = [];
                    for (let key in userData) {
                        const userItemData = userData[key].map((item) => {
                            return {
                                ...item,
                                files_image: item.files.length
                                    ? item.files.filter((file) => !file.file_type && !file.file_size)
                                    : [],
                                files_file: item.files.length
                                    ? item.files.filter((file) => file.file_size || file.file_type)
                                    : [],
                            };
                        });
                        feedBackData.push({
                            id: key + "",
                            uid: userData[key][0].uid,
                            name: userData[key][0]?.user?.name,
                            data: userItemData,
                        });
                    }
                    this.feedBackData = feedBackData || [];
                    this.feedBackTabData = this.feedBackData.length ? this.feedBackData[0].data : [];
                    this.feedBackTabActiveId =
                        this.feedBackTabData && this.feedBackTabData.length ? this.feedBackTabData[0].uid : "";
                    this.finishAllData = finish || [];
                    this.finishData = finish ? finish[0] : {};

                    this.loading = false;
                } else {
                    this.$message.error(res.message);
                    this.loading = false;
                }
            });
        },
        groupUserData(data) {
            const grouped = data.reduce((result, item) => {
                const key = item.uid; // 分组依据的属性
                if (!result[key]) {
                    result[key] = []; // 初始化该类型的数组
                }
                result[key].push(item); // 将元素加入对应分组
                return result;
            }, {}); // 初始值为空对象
            return grouped;
        },
        formatDate(dateString, date_type) {
            // 创建日期对象
            const dateObj = new Date(dateString);
            // 获取年、月、日
            const year = dateObj.getFullYear();
            const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
            const day = ("0" + dateObj.getDate()).slice(-2);
            const hours = ("0" + dateObj.getHours()).slice(-2);
            const minutes = ("0" + dateObj.getMinutes()).slice(-2);
            const seconds = ("0" + dateObj.getSeconds()).slice(-2);
            let formattedDateTime = "";
            if (date_type === "date") {
                formattedDateTime = year + "/" + month + "/" + day;
            } else if (date_type === "year-month") {
                formattedDateTime = year + "/" + month;
            } else if (date_type === "datetime") {
                formattedDateTime = year + "/" + month + "/" + day + " " + hours + ":" + minutes;
            } else if (date_type === "hourtime") {
                formattedDateTime = hours + ":" + minutes + ":" + seconds;
            } else if (date_type === "month") {
                formattedDateTime = month + "/" + day;
            } else if (date_type === "date-second-time") {
                formattedDateTime = year + "/" + month + "/" + day + " " + hours + ":" + minutes + ":" + seconds;
            }
            return formattedDateTime;
        },
        // 切换工单处理详情
        handleClickUserTab(user, index) {
            this.feedBackTabActiveId = user.uid;
            this.feedBackTabData = this.feedBackData[index]?.data || [];
        },
        //附件预览事件
        handleClickPreview(file) {
            if (file.file_type.includes("image")) {
                this.previewImgList = [file.file_path];
                this.previewImgSrc = file.file_path;
                this.$refs.preview_img.showViewer = true;
            } else {
                if (file.file_type.includes("pdf")) {
                    window.open(file.file_path);
                } else {
                    this.$toast("当前文件类型不支持预览");
                }
            }
        },
        handleClickDownloadFile(file) {
            getOSSData(file.file_path, file.file_name);
        },
        // 查看评价内容
        handleClickShowContent(content) {
            this.evaluateContent = content;
            this.showEvaluateContent = true;
        },
        handleClickMore() {
            this.activeItem = JSON.parse(JSON.stringify(this.workOrderDetailsData));
            this.handleRadioPicker = true;
        },
        //删除工单
        handleClickDelWorkOrder(row) {
            Dialog.confirm({
                title: "删除工单",
                message: "确定要删除所选工单吗？",
                className: "my_dialog",
                confirmButtonColor: "rgba(228, 65, 68, 1)",
                confirmButtonText: "确定",
            }).then(() => {});
        },
        //工单详情
        handleClickWorkOrderDetail(row) {
            this.$router.push({
                name: "WorkOrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    work_order_id: row.id,
                    name: row.workorder_num,
                },
            });
        },
        //撤销工单
        handleClickRevokeWorkOrder(row) {
            Dialog.confirm({
                title: "撤销工单",
                message: "确定要撤销所选工单吗？",
                className: "my_dialog",
                confirmButtonColor: "rgba(41, 144, 255, 1)",
                confirmButtonText: "撤销",
            }).then(() => {});
        },
        // 关闭工单
        handleClickCloseWorkOrder(row) {
            Dialog.confirm({
                title: "关闭工单",
                message: "确定要关闭所选工单吗？",
                className: "my_dialog",
                confirmButtonColor: "rgba(41, 144, 255, 1)",
                confirmButtonText: "确定",
            }).then(() => {
                workOrderClose({ workorder_id: row.id, workorder_num: row.workorder_num }).then((res) => {
                    if (res.code === 200) {
                        this.$toast(res.message);
                        this.initData();
                    }
                });
            });
        },
        //再次发起工单
        handleClickRestartWorkOrder(row) {
            this.$router.push({
                name: "WorkOrderAddAgain",
                params: {
                    isPush: true,
                },
                query: {
                    work_order_id: row.id,
                },
            });
        },
        //分配实施人员
        handleClickDistributeWorkOrder(row) {
            this.processing_users_selected_ids = (this.assignData || []).filter(user=> user.status !== 3)
                .map((item) => {
                    return item.processing_user;
                })
                .map((item) => item.id);
            this.workOrderAssignPopupShow = true;
        },
        //替换实施人员
        handleClickReplaceWorkOrder(row) {
            this.processingUserSelectedList = (this.assignData || []).map((item) => {
                return item.processing_user;
            });
            this.workOrderUserReplacePopupShow = true;
        },
        //撤回实施人员
        handleClickRevokeDistributeWorkOrder(row) {
            this.processingUserSelectedList = (this.assignData || []).filter(item=> item.status !== 3).map((item) => {
                return item.processing_user;
            });
            this.workOrderUserRevokePopupShow = true;
        },
        //工单出发
        handleClickStartWorkOrder(row) {
            if(this.workOrderDetailsData.processing_approval_id && this.workOrderDetailsData.processing_approval_status === 0) return this.$toast("您已发起工单出发申请，请等待审批通过!")
            this.$router.push({
                name: "WorkOrderTravel",
                query: {
                    id: row.id,
                    workorder_num: row.workorder_num,
                    assign_id: row.assign_id || 0,
                    travelInfo: {
                        project_id: row.project_id.value,
                        project_name: row.project_id.text,
                        order_id: row.order_id.value,
                        order_num: row.order_id.text,
                    },
                },
            });
        },
        //工单实施开始
        handleClickWorkOrderImplementStart(row) {
            Dialog.confirm({
                title: "实施开始",
                message: "确定现在已到达现场并开始实施吗？",
                className: "my_dialog",
                confirmButtonColor: "rgba(41, 144, 255, 1)",
                confirmButtonText: "确定",
            }).then(() => {
                const params = {
                    workorder_id: row.id,
                    workorder_num: row.workorder_num,
                    processing_uid: this.owner_uid,
                    processing_name: this.userInfo && this.userInfo.user && this.userInfo.user.name,
                };
                workOrderFeedbackStart(params).then((res) => {
                    if (res.code === 200) {
                        this.$toast(res.message);
                        this.initData();
                    }
                });
            });
        },
        //工单转单
        handleClickTransferWorkOrder(row) {
            this.$router.push({
                name: "WorkOrderTransfer",
                query: {
                    id: row.id,
                    processing_user_ids: (row.processing_users || [])
                        .map((item) => {
                            return item.processing_user;
                        })
                        .map((item) => item.id),
                },
            });
        },
        //工单每日工作填写
        handleClickWorkOrderDailyWork(row) {
            this.$router.push({
                name: "WorkOrderFeedBack",
                query: {
                    id: row.id,
                },
            });
        },
        //工单实施结束
        handleClickWorkOrderImplementEnd(row) {
            // 1=极简模式,2=简约工程模式
            const mode = row.mode;
            if (mode === 1) {
                Dialog.confirm({
                    title: "实施结束",
                    message: "确定现在已完成实施了吗？",
                    className: "my_dialog",
                    confirmButtonColor: "rgba(41, 144, 255, 1)",
                    confirmButtonText: "确定",
                }).then(() => {
                    workOrderFeedbackEnd({ workorder_id: row.id, workorder_num: row.workorder_num }).then((res) => {
                        if (res.code === 200) {
                            this.$toast(res.message);
                            this.initData();
                        }
                    });
                });
            } else {
                this.workorder_num = row.workorder_num;
                this.workOrderFeedBackFinishPopupShow = true;
            }
        },
        //工单结单
        handleClickEndWorkOrder(row) {
            const isAllFinish = row.processing_users.every((user) => user.status === 3);
            if (isAllFinish) {
                this.$router.push({
                    name: "WorkOrderFinish",
                    query: {
                        id: row.id,
                        workorder_num: row.workorder_num,
                        finishInfo: {
                            project_id: row.project_id.value,
                            project_name: row.project_id.text,
                            order_id: row.order_id.value,
                            order_num: row.order_id.text,
                        },
                    },
                });
            } else {
                this.$toast("全部实施人实施完成后才可以结单");
            }
        },
        //工单评价
        handleClickEvaluateWorkOrder(row) {
            this.workorder_num = row.workorder_num;
            this.processingUserSelectedList = (this.assignData || []).map((item) => {
                return item.processing_user;
            });
            this.workOrderEvaluatePopupShow = true;
        },
    },
};
</script>
<style lang="scss" scoped>
::v-deep .van-tabs {
    flex: 1;
    max-height: calc(100% - 44px);

    .van-tab {
        font-size: 16px;

        &.van-tab--active {
            font-weight: 700;
        }
    }

    .van-tabs__content {
        width: 100%;
        height: calc(100% - 44px);

        .van-tab__pane {
            width: 100%;
            height: 100%;
        }
    }

    .van-tabs__line {
        width: 60px;
    }
}
.detail_tab_content {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding: 12px 16px;
    border-top: 1px solid rgba(232, 232, 232, 1);
}
.detail_assign_tab_content,
.user_tab_content_wrap {
    .list_item {
        border-radius: 6px;
        border: 2px solid rgba(232, 232, 232, 1);
        margin-bottom: 4px;
        padding: 8px;
        .list_item_field {
            display: flex;
            align-items: center;
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(51, 51, 51, 1);
            & + .list_item_field {
                margin-top: 8px;
            }
            .list_item_field_label {
                color: rgba(153, 153, 153, 1);
            }
            &.list_item_field_status {
                justify-content: space-between;
                & > div {
                    display: flex;
                    align-items: center;
                }
            }
            &.list_item_field_vertical {
                flex-direction: column;
                align-items: flex-start;
            }
        }
        .work_order_status {
            position: relative;
            padding-left: 10px;
            color: rgba(102, 102, 102, 1);

            &::before {
                content: "";
                position: absolute;
                left: 0;
                top: 50%;
                margin-top: -3px;
                width: 6px;
                height: 6px;
                opacity: 1;
                border-radius: 50%;
            }

            &.work_order_status0,
            &.work_order_status1,
            &.work_order_status2,
            &.work_order_status3,
            &.work_order_status4 {
                &::before {
                    background-color: rgba(240, 170, 50, 1);
                }
            }

            &.work_order_status-1 {
                &::before {
                    background-color: rgba(228, 65, 68, 1);
                }
            }

            &.work_order_status-2,
            &.work_order_status-3,
            &.work_order_status7 {
                &::before {
                    background-color: rgba(191, 191, 191, 1);
                }
            }

            &.work_order_status5,
            &.work_order_status6 {
                &::before {
                    background-color: rgba(90, 179, 51, 1);
                }
            }
        }
        .handle_icon_wrap_shuoming {
            margin-left: 4px;
            i {
                color: #f0aa32;
            }
        }
    }
}
.user_tab_wrap {
    overflow-x: auto;
    span {
        display: inline-block;
        vertical-align: top;
        padding: 4px 12px;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(102, 102, 102, 1);
        border-radius: 15px;
        background: rgba(247, 248, 250, 1);
        margin-bottom: 18px;
        &.active {
            background-color: rgba(41, 144, 255, 0.16);
            color: rgba(41, 144, 255, 1);
            font-weight: 700;
        }
        & + span {
            margin-left: 12px;
        }
    }
}
.image_outer_wrap {
    .image_upload_wrap {
        width: 32px;
        height: 32px;
        opacity: 1;
        border-radius: 4px;
        background: #edf0f4;
        text-align: center;
        line-height: 32px;
        margin-bottom: 2px;
        cursor: pointer;
        position: relative;

        .upload_input {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            opacity: 0;
            cursor: pointer;
        }
    }

    .upload_image_list {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;

        .upload_image_item {
            width: 32px;
            height: 32px;
            opacity: 1;
            border-radius: 4px;
            text-align: center;
            line-height: 32px;
            position: relative;
            margin-bottom: 4px;

            .el-image {
                width: 100%;
                height: 100%;
                border-radius: 4px;
            }

            .el-icon-error {
                position: absolute;
                right: -8px;
                top: -8px;
                color: #999999;
                font-size: 16px;
                cursor: pointer;
            }
        }
    }

    .image_hint {
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 18px;
        color: #999999;
    }
}
.commentFiles {
    width: 100%;
    ul {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        min-height: 26px;
        padding-bottom: 10px;
        li {
            width: 100%;
            margin-bottom: 4px;
            border-radius: 2px;
            background: rgba(249, 249, 249, 1);
            border: 1px solid rgba(217, 217, 217, 1);
            line-height: 20px;
            height: 22px;
            padding: 0 8px;
            box-sizing: border-box;
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: center;
            p {
                font-size: 12px;
                color: rgba(102, 102, 102, 1);
                width: calc(100% - 50px);
            }
            div {
                width: 40px;
                display: flex;
                justify-content: space-between;
                span.handle_icon_wrap {
                    width: 16px;
                    height: 16px;
                    font-size: 12px;
                    line-height: 16px;
                    i {
                        font-size: 12px;
                    }
                }
            }
        }
    }
}
.detail_finish_tab_content {
    .list_item_form {
        margin-bottom: 12px;
        .list_item_label {
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 18px;
            color: rgba(153, 153, 153, 1);
            margin-bottom: 4px;
        }
        .list_item_content {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(51, 51, 51, 1);
        }
    }
    .file_upload_wrap {
        height: auto;
    }
}
.custom_evaluate_dialog {
    border-radius: 8px;
    box-shadow: 0px 12px 48px 16px #000000;
    .evaluate_content_wrap {
        padding: 16px;
        .evaluate_content_wrap_title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 16px;
            font-weight: 700;
            letter-spacing: 0px;
            line-height: 24px;
            color: rgba(34, 34, 34, 1);
            .van-icon {
                color: #666666;
                font-size: 20px;
            }
        }
        .evaluate_content_wrap_content {
            margin-top: 16px;
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(102, 102, 102, 1);
        }
    }
}
</style>
